export const GTM_EVENT_AFTER_SALES_PRODUCTS_RETURN_REQUESTED_EVENT =
  'returnRequested'
export const GTM_EVENT_AFTER_SALES_PRODUCTS_RETURN_PAGE_OPEN_EVENT =
  'returnRequestPageOpen'
export const GTM_EVENT_PRODUCTS_RETURN_REFUND_BY_CS_CREATED_EVENT =
  'returnRefundByCsCreated'
export const GTM_EVENT_PRODUCTS_RETURN_LABEL_BY_CS_CREATED_EVENT =
  'returnLabelByCsCreated'
export const GTM_EVENT_PRODUCTS_RETURN_REFUND_CREATED_EVENT =
  'returnRefundCreated'

export const UDP_TRACKING_EVENT_ADD_TO_CART = 'udpA2c'
export const UDP_TRACKING_EVENT_CART_REMOVE = 'udpCartRemove'
export const UDP_TRACKING_EVENT_CLICK = 'udpClick'
export const UDP_TRACKING_EVENT_IMPRESSION = 'udpImpr'
export const UDP_TRACKING_EVENT_RECOMMENDATION_RESPONSE = 'udpRecoResponse'
export const UDP_TRACKING_EVENT_SEARCH = 'udpSearch'
export const UDP_TRACKING_EVENT_PURCHASE = 'udpBuy'
